// @ts-nocheck
import { useCallback } from 'react';

import useWorkflow from '../../../hooks/Configuration/useWorkflow';
import useCommon from '../../../hooks/useCommon';

const useWorkflowGroups = () => {
  const { getWorkflowGroups } = useWorkflow();
  const { setWorkflowGroupNodes, setCurrentWorkflowGroupId, dispatch } =
    useCommon();

  const fetchWorkflowGroups = useCallback(
    ({
      template_id,
      template_version_id,
      entity_current_status = null,
      entity_id,
      entity_type,
      loader = true,
    }) => {
      getWorkflowGroups(
        { template_id, version_id: template_version_id },
        loader
      ).then((res) => {
        if (res?.data) {
          const nodes = res.data.map((group) => {
            return {
              label: group?.group_name,
              value: group?.workflow_group_id,
              ...group,
            };
          });
          dispatch(
            setWorkflowGroupNodes({ entity_id, entity_type, data: nodes })
          );
          // Find the workflow group whose states include the entity's current status.
          // Falls back to the first group if no match is found.
          const matchedNode = nodes?.find((node) =>
            node?.states?.includes(entity_current_status)
          );
          const currentGroupId =
            matchedNode?.workflow_group_id ?? nodes[0]?.workflow_group_id;
          dispatch(
            setCurrentWorkflowGroupId({
              entity_id,
              entity_type,
              data: currentGroupId,
            })
          );
        }
      });
    },
    [getWorkflowGroups, setWorkflowGroupNodes, dispatch]
  );

  return { fetchWorkflowGroups };
};

export default useWorkflowGroups;
